// Components
import { useCallback, useEffect } from 'react';
import DiscardConfirmation, {
  useDiscardConfirmation,
} from 'components/DiscardConfirmation';
// Utils
import { getText } from 'i18n/intl';
import { fetchFields } from 'slices/field.slice';
import { requestObjectTypes } from 'slices/objectTypes.slice';
// Slices
import {
  checkPaddingSaveDisabled,
  fetchPaddingRules,
} from 'slices/paddingRules.slice';
import { useAppDispatch } from 'slices/store';
import { DefaultContentLayout } from '@timeedit/ui-components';
import PaddingRuleDrawer from './PaddingRuleDrawer';
import PaddingRuleList from './PaddingRuleList';

const PaddingRulesPage = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(fetchPaddingRules());
    dispatch(fetchFields());
    dispatch(requestObjectTypes());
  }, []);

  const [
    openDiscardDialog,
    onCloseDiscardDialog,
    confirmFn,
    confirmDiscardChanged,
  ] = useDiscardConfirmation();

  const confirmDiscardPaddingChanges = useCallback(
    (isFirstDrawer: boolean, actionFn: () => void) => {
      const isFieldRelationDisabled = dispatch(
        checkPaddingSaveDisabled(isFirstDrawer)
      );
      if (!isFieldRelationDisabled) {
        return confirmDiscardChanged(actionFn);
      }
      actionFn();
    },
    []
  );

  return (
    <DefaultContentLayout
      title={getText('system_padding_rule_title')}
      subtitle={getText('system_padding_rule_subtitle')}
    >
      <div className="inner-content--wrapper">
        <PaddingRuleList
          confirmDiscardPaddingChanges={confirmDiscardPaddingChanges}
        />
        <PaddingRuleDrawer
          confirmDiscardPaddingChanges={confirmDiscardPaddingChanges}
        />
      </div>
      <DiscardConfirmation
        open={openDiscardDialog}
        onClose={onCloseDiscardDialog}
        confirmFn={confirmFn}
      />
    </DefaultContentLayout>
  );
};

export default PaddingRulesPage;
